module.exports = __webpack_public_path__ + "static/assets/092fb09b7cfcb74e637f000c6be85ef2.svg";